import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MatchingOverview } from '@app/core/api/matching-analytics';
import { AnalyticsQueryParams } from '@app/core/api/analytics-shared';

export const MatchingAnalyticsActions = createActionGroup({
  source: 'Matching Analytics',
  events: {
    'Load Overview': props<{ params: AnalyticsQueryParams }>(),
    'Load Overview Success': props<{ overview: MatchingOverview }>(),
    'Load Overview Failure': props<{ error: string }>(),

    'Clear Matching Analytics State': emptyProps(),
  }
});
